import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { OCCASION_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
// import useAuth from "../../../../authentication/hooks/useAuth";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import MasterConfigHeaderWithoutDeleteWrapper from "../../../../common/master-config/MasterConfigHeaderWithoutDeleteWrapper";
import GenericModal from "../../../../reusable-components/modals/GenericModal";
import showToast from "../../../../utilities/notification/NotificationModal";

import AddOccasionTypeForm from "./addOccasionTypeForm.component";
import OccasionTypeList from "./occasionTypeList.component";

const OccasionTypeConfig = () => {
  // const { auth } = useAuth();
  const [occasionTypeList, setOccasionTypeList] = useState([]);
  // const axiosPrivate = useAxiosPrivate();
  const [showAddForm, setShowAddForm] = useState(false);
  const [editOccasionTypeDetails, setEditOccasionTypeDetails] = useState({});
  const isEdit = Object.keys(editOccasionTypeDetails).length > 0 ? true : false;

  const getOccasionTypeList = async () => {
    try {
      const response = await axios.get(OCCASION_TYPE_CONFIG_URL);
      // console.log("Occasion Type List", { response });
      response.status === 200 &&
        setOccasionTypeList(response.data.occasionTypeList);
      response.status === 202 &&
        showToast("No occasion type found in the system.", "error");
    } catch (error) {
      console.error("getOccasionTypeList", error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getOccasionTypeList();
      setEditOccasionTypeDetails({});
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    // <Dashboard sidebarType={auth.rolename}>
    <Dashboard>
      <ToastContainer />
      <MasterConfigHeaderWithoutDeleteWrapper
        headerTitle={"Occasion Type"}
        setShowAddForm={setShowAddForm}
      />
      <GenericModal
        open={showAddForm}
        setOpen={setShowAddForm}
        title={` ${
          isEdit ? "Update Occasion Type Details" : "Add Occasion Type Details"
        }`}
        isAdd={true}
        clearData={setEditOccasionTypeDetails}
      >
        <AddOccasionTypeForm
          getOccasionTypeList={getOccasionTypeList}
          editOccasionTypeDetails={editOccasionTypeDetails}
          setEditOccasionTypeDetails={setEditOccasionTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </GenericModal>
      <div className="grid grid-cols-1">
        <OccasionTypeList
          occasionTypeList={occasionTypeList}
          getOccasionTypeList={getOccasionTypeList}
          setEditOccasionTypeDetails={setEditOccasionTypeDetails}
          setShowAddForm={setShowAddForm}
        />
      </div>
    </Dashboard>
  );
};

export default OccasionTypeConfig;
